import { BaseClass } from '../base/BaseClass';

export class VideoSelector extends BaseClass {
  /**
   * @desc An array of html video selections.
   *
   * @type {HTML Nodes}
   */
  videoSelections;

  /**
   * @desc The video iframe node
   *
   * @type {HTML Nodes}
   */
  videoPlayer;

  /**
   * @desc Video selector selected class name.
   *
   * @type {String}
   */
  selectedClass = 'videos__video-active';

  /**
   * @class
   *
   * @extends {BaseClass}
   *
   * @desc Controls video playback when a new link is clicked.
   *
   * @param {HTMLNode} dropdownEl
   */
  constructor(identifier) {
    super(identifier);
    if (this.targetExists()) {
      this.videoSelections = this.target.querySelectorAll(
        '.videos__video-selection'
      );
      this.videoPlayer = this.target.querySelector('iframe');
      this.init();
    }
  }

  /**
   * @desc Initialise the class functionality
   */
  init = () => {
    this.videoSelections.forEach((videoSelection) => {
      videoSelection.addEventListener('click', this.handleClick);
    });
  };

  /**
   * @desc Handle the video selection click
   *
   * @param {HTML Node} e
   */
  handleClick = (e) => {
    const videoSelection = e.target;
    const videoSrc = videoSelection.getAttribute('data-video-src');
    const videoTitle = videoSelection.innerText;
    this.updatePlayerAttr('title', videoTitle);
    this.updatePlayerAttr('src', videoSrc);
    this.updateActiveClass(videoSelection);
  };

  /**
   * @desc Update the video plater attributes
   *
   * @param {string} attr
   *
   * @param {string} data
   */
  updatePlayerAttr = (attr, data) => {
    this.videoPlayer.setAttribute(attr, data);
  };

  /**
   * @desc Update the video selection active classes
   *
   * @param {HTML Node} newSelection
   */
  updateActiveClass = (newSelection) => {
    this.videoSelections.forEach((videoSelection) => {
      videoSelection === newSelection
        ? videoSelection.classList.add(this.selectedClass)
        : videoSelection.classList.remove(this.selectedClass);
    });
  };
}
